import api from '../api/api';
import { OrganisationSearchResult } from '../../types/OrganisationSearchResult';
import Organisation from '../../types/Organisation';

class OrganisationService {
  static async searchOrganisations(
    query: string,
    page = 0,
    resultsPerPage = 50
  ): Promise<OrganisationSearchResult> {
    const apiResponse = await api.get<OrganisationSearchResult>(
      '/organisations',
      { params: { query, page, resultsPerPage } }
    );
    return apiResponse.data;
  }

  static async getOrganisation(organisationId: number): Promise<Organisation> {
    const apiResponse = await api.get<Organisation>(
      `/organisations/${organisationId}`
    );
    return apiResponse.data;
  }

  static async createOrganisation(name: string): Promise<Organisation> {
    const apiResponse = await api.post<Organisation>('/organisations', {
      name
    });
    return apiResponse.data;
  }

  static async updateOrganisation(
    organisationId: number,
    name: string
  ): Promise<Organisation> {
    const apiResponse = await api.put<Organisation>(
      `/organisations/${organisationId}`,
      { name }
    );
    return apiResponse.data;
  }

  static async deleteOrganisation(organisationId: number): Promise<void> {
    await api.delete(`/organisations/${organisationId}`);
  }
}

export default OrganisationService;
